var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllPasswordreq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380,
    height: 117.091,
    viewBox: "0 0 380 117.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ill_passwordreq",
    transform: "translate(190 58.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ill_passwordreq-2",
    "data-name": "ill_passwordreq",
    transform: "translate(-190 -58.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119895",
    "data-name": "Path 119895",
    d: "M42.6,46.856A122.968,122.968,0,0,0,78.75,19.078c6.549-7.245,13.883-11.489,22.6-7.017h0A35.175,35.175,0,0,0,130.8,13.4l2.407-.975a102.372,102.372,0,0,1,78.065.19l16.315,6.726a35.074,35.074,0,0,0,20.811,1.875,35.112,35.112,0,0,1,17.619.874h0a46.626,46.626,0,0,0,34.542-3.1c14.415-7.233,24.877-11.121,42.611-1.115h0c16.34,9.221,32.325,17.024,35.695,36.645,3.116,18.151-9.855,32.186,4.129,43.4l7.955,6.333H31.212C14.771,69.656,28.4,53.949,42.6,46.856Z",
    transform: "translate(-15.822 -4.79)",
    fill: "#f7d084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119896",
    "data-name": "Path 119896",
    d: "M396.213,84.913H18.747a1.267,1.267,0,0,1,0-2.533H396.213a1.267,1.267,0,1,1,0,2.533Z",
    transform: "translate(-17.48 15.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119897",
    "data-name": "Path 119897",
    d: "M224.847,58.434v53.314a3.8,3.8,0,0,1-3.8,3.8H133.9a3.8,3.8,0,0,1-3.8-3.8V58.434a3.8,3.8,0,0,1,3.8-3.8h11.4v-14.5c.025-18,14.731-33.2,32.718-32.87a32.2,32.2,0,0,1,31.6,32.135V54.6h11.4a3.8,3.8,0,0,1,3.825,3.838Zm-32.148-19a15.2,15.2,0,1,0-30.4,0v15.2h30.4Z",
    transform: "translate(12.552 -4.132)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119898",
    "data-name": "Path 119898",
    d: "M173.2,13.741C159.179,13.5,147.69,26.053,147.69,40.923V52.906h9.867v-15.2a15.2,15.2,0,0,1,30.4,0v15.2h9.867V40.315C197.875,25.812,186.843,13.981,173.2,13.741Z",
    transform: "translate(17.243 -2.404)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119899",
    "data-name": "Path 119899",
    d: "M130.1,48.46v53.314a3.8,3.8,0,0,0,3.8,3.8h87.147a3.8,3.8,0,0,0,3.8-3.8V48.46a3.8,3.8,0,0,0-3.8-3.8H133.9a3.8,3.8,0,0,0-3.8,3.8Z",
    transform: "translate(12.552 5.843)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5563",
    "data-name": "Rectangle 5563",
    width: 94.759,
    height: 12.413,
    transform: "translate(142.652 62.903)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119900",
    "data-name": "Path 119900",
    d: "M130.1,83.84v7.486a3.8,3.8,0,0,0,3.8,3.8h87.147a3.8,3.8,0,0,0,3.8-3.8V83.84Z",
    transform: "translate(12.552 16.291)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5564",
    "data-name": "Rectangle 5564",
    width: 94.759,
    height: 12.413,
    transform: "translate(142.652 75.317)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119901",
    "data-name": "Path 119901",
    d: "M130.1,48.46v8.6h94.747v-8.6a3.8,3.8,0,0,0-3.8-3.8H133.9a3.8,3.8,0,0,0-3.8,3.8Z",
    transform: "translate(12.552 5.843)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5565",
    "data-name": "Rectangle 5565",
    width: 94.759,
    height: 12.413,
    transform: "translate(142.652 87.717)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119902",
    "data-name": "Path 119902",
    d: "M224.967,55.267H130.233a.633.633,0,0,1,0-1.267h94.734a.646.646,0,0,1,.633.633A.633.633,0,0,1,224.967,55.267Z",
    transform: "translate(12.419 8.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119903",
    "data-name": "Path 119903",
    d: "M224.967,84.607H130.233a.633.633,0,1,1,0-1.267h94.734a.633.633,0,0,1,.633.633A.646.646,0,0,1,224.967,84.607Z",
    transform: "translate(12.419 16.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119904",
    "data-name": "Path 119904",
    d: "M152.514,65.017H130.233a.633.633,0,1,1,0-1.267h22.281a.633.633,0,1,1,0,1.267Z",
    transform: "translate(12.419 10.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119905",
    "data-name": "Path 119905",
    d: "M142.381,74.807H130.233a.633.633,0,0,1,0-1.267h12.147a.633.633,0,0,1,0,1.267Z",
    transform: "translate(12.419 13.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119906",
    "data-name": "Path 119906",
    d: "M207.057,65.017h-9.614a.633.633,0,0,1,0-1.267h9.614a.633.633,0,1,1,0,1.267Z",
    transform: "translate(30.341 10.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119907",
    "data-name": "Path 119907",
    d: "M210.257,74.807H185.443a.633.633,0,0,1,0-1.267h24.814a.633.633,0,0,1,0,1.267Z",
    transform: "translate(27.141 13.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119908",
    "data-name": "Path 119908",
    d: "M221.313,117.081H134.167a5.067,5.067,0,0,1-5.067-5.067V58.7a5.067,5.067,0,0,1,5.067-5.067H144.3V40.4a34.656,34.656,0,0,1,10.336-24.548,32.705,32.705,0,0,1,23.636-9.589,33.554,33.554,0,0,1,32.857,33.4V53.6h10.133a5.067,5.067,0,0,1,5.067,5.067v53.352a5.067,5.067,0,0,1-5.016,5.067ZM134.167,56.167a2.533,2.533,0,0,0-2.533,2.533v53.314a2.533,2.533,0,0,0,2.533,2.533h87.147a2.533,2.533,0,0,0,2.533-2.533V58.7a2.533,2.533,0,0,0-2.533-2.533H208.647V39.7a31.008,31.008,0,0,0-30.4-30.869A30.172,30.172,0,0,0,156.435,17.7a32.135,32.135,0,0,0-9.589,22.8V56.167Zm60.065,0H161.3V39.7a16.467,16.467,0,1,1,32.933,0Zm-30.4-2.533H191.7V39.7a13.933,13.933,0,0,0-27.867,0Z",
    transform: "translate(12.285 -4.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119909",
    "data-name": "Path 119909",
    d: "M158.7,46.193H142.387a1.267,1.267,0,0,1,0-2.533H158.7a1.267,1.267,0,0,1,0,2.533Z",
    transform: "translate(15.491 5.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119910",
    "data-name": "Path 119910",
    d: "M196.063,46.193H179.787a1.267,1.267,0,0,1,0-2.533h16.277a1.267,1.267,0,1,1,0,2.533Z",
    transform: "translate(25.464 5.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119911",
    "data-name": "Path 119911",
    d: "M45.184,24.713l1.343,9.918h.127l6.447-7.6,3.167,3.255-8.322,6.067v.127l9.905,1.545-1.267,4.294-9.272-3.889v.127l3.8,9.361-4.649,1.1-1.191-9.956h-.127l-6.7,7.613-2.939-3.331L43.778,37.4v-.127l-9.7-1.545,1.267-4.294,8.943,3.927v-.127l-3.61-9.475,4.509-1.077m0-2.533a2.382,2.382,0,0,0-.6,0l-4.5,1.077a2.533,2.533,0,0,0-1.773,3.382l1.533,3.927-3.445-1.507a2.407,2.407,0,0,0-1.026-.215,2.457,2.457,0,0,0-1.064.241,2.533,2.533,0,0,0-1.368,1.583l-1.267,4.294a2.533,2.533,0,0,0,2.027,3.2l3.8.608L34.088,41.2a2.535,2.535,0,0,0-.431,3.724L36.6,48.26a2.533,2.533,0,0,0,1.9.861h0a2.533,2.533,0,0,0,1.913-.861l3.1-3.5.532,4.459a2.532,2.532,0,0,0,2.521,2.229,3.04,3.04,0,0,0,.583,0l4.649-1.1a2.533,2.533,0,0,0,1.761-3.433L52,43.117l3.623,1.558a2.647,2.647,0,0,0,.988.2,2.723,2.723,0,0,0,1.089-.241,2.533,2.533,0,0,0,1.343-1.583l1.267-4.294a2.6,2.6,0,0,0-2.09-3.243l-4-.621,3.572-2.635a2.533,2.533,0,0,0,.317-3.8l-3.192-3.255A2.533,2.533,0,0,0,53.1,24.5h-.089a2.533,2.533,0,0,0-1.849.9l-2.875,3.433-.6-4.459a2.53,2.53,0,0,0-2.508-2.191Z",
    transform: "translate(-13.72 -0.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119912",
    "data-name": "Path 119912",
    d: "M237.313,30.023l4.6,1.267-3.939,9.88h.139l9.842-4.332,1.267,4.915-10.463,1.583v.127l8.36,6.941-3.458,3.2L237.123,45h-.139L235.6,55.344,231,54.077l3.927-9.6H234.8l-9.981,4.079-1.267-4.75,10.513-1.7v-.127l-8.373-6.65,3.369-3.395,6.739,8.677h.139l1.368-10.577m0-2.533a2.533,2.533,0,0,0-2.533,2.217l-.6,4.649-3.129-4.028a2.533,2.533,0,0,0-1.849-.975h-.152a2.533,2.533,0,0,0-1.811.76l-3.369,3.445a2.533,2.533,0,0,0,.228,3.8l4,3.179-5.067.811A2.53,2.53,0,0,0,221,44.514l1.267,4.75a2.533,2.533,0,0,0,1.33,1.621,2.445,2.445,0,0,0,1.115.266,2.407,2.407,0,0,0,.975-.2l4.484-1.875-1.545,3.99a2.462,2.462,0,0,0,1.685,3.357l4.6,1.267a2.355,2.355,0,0,0,.659.089,2.533,2.533,0,0,0,2.533-2.2l.583-4.37,2.939,3.876a2.533,2.533,0,0,0,1.8.988h.228a2.533,2.533,0,0,0,1.71-.671l3.395-3.192a2.533,2.533,0,0,0-.1-3.8L244.533,45l5.067-.735a2.533,2.533,0,0,0,2.077-3.154l-1.267-4.915a2.533,2.533,0,0,0-2.445-1.887,2.609,2.609,0,0,0-1.026.215l-4.383,1.925,1.685-4.256a2.472,2.472,0,0,0-1.7-3.344l-4.6-1.267a2.837,2.837,0,0,0-.646-.089Z",
    transform: "translate(36.768 1.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119913",
    "data-name": "Path 119913",
    d: "M85.2,60.373l.19,6.536h.076l4.674-4.585,1.837,2.318L86.2,68.087v.076L92.531,69.8l-1.089,2.7-5.713-3.141v.089l1.887,6.333-3.078.418L84.4,69.671H84.31l-4.839,4.56-1.7-2.343,5.738-3.319V68.48l-6.194-1.621,1.089-2.7,5.523,3.065V67.15l-1.786-6.333,3.053-.443m0-2.533h-.342l-2.989.418a2.521,2.521,0,0,0-2.09,3.192l.165.583-.279-.152a2.533,2.533,0,0,0-1.267-.329,2.685,2.685,0,0,0-.836.139,2.533,2.533,0,0,0-1.533,1.419L74.937,65.82a2.545,2.545,0,0,0,1.748,3.395l.317.076-.519.3a2.533,2.533,0,0,0-.785,3.673l1.685,2.343a2.533,2.533,0,0,0,1.811,1.039h.253a2.533,2.533,0,0,0,1.735-.684l.773-.735v.937A2.533,2.533,0,0,0,84.488,78.7h.342l3.053-.393a2.533,2.533,0,0,0,2.09-3.23l-.152-.507.355.19a2.457,2.457,0,0,0,1.267.317,2.711,2.711,0,0,0,.849-.139A2.609,2.609,0,0,0,93.8,73.5l1.039-2.787a2.47,2.47,0,0,0-1.723-3.357l-.494-.127.659-.393a2.533,2.533,0,0,0,.684-3.8l-1.837-2.318a2.533,2.533,0,0,0-1.862-.9h-.127a2.533,2.533,0,0,0-1.773.735l-.646.633V60.3A2.557,2.557,0,0,0,85.2,57.84Z",
    transform: "translate(-2.205 9.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119914",
    "data-name": "Path 119914",
    d: "M110.529,18.051l1.267,10.26.1.089,6.156-7.9,3.192,3.243-7.917,6.131.089.1,10.057,1.191-1.267,4.6-9.285-3.8-.1.089,3.471,9.614-4.332.95L110.77,32.479l-.089-.089-6.067,7.727-3.141-3.179,7.777-5.9-.089-.1L99.116,29.553l1.267-4.459,9.323,3.661.1-.089L106.2,19.28l4.383-1.191m0-2.533a2.939,2.939,0,0,0-.659.089l-4.383,1.178a2.533,2.533,0,0,0-1.71,3.357l1.609,4.18L101.3,22.738a2.462,2.462,0,0,0-3.319,1.685L96.71,28.881a2.533,2.533,0,0,0,2.09,3.192l4.18.57-3,2.267a2.59,2.59,0,0,0-.342,3.762l3.141,3.192a2.533,2.533,0,0,0,1.8.747h.127a2.533,2.533,0,0,0,1.849-.963l2.331-2.989.494,4.193a2.533,2.533,0,0,0,1.039,1.761,2.457,2.457,0,0,0,2.014.418l4.345-.937a2.56,2.56,0,0,0,1.837-3.357l-1.545-4.332,4.1,1.634A2.436,2.436,0,0,0,124.5,36.38l1.267-4.6a2.533,2.533,0,0,0-2.141-3.2l-4.091-.481,3.116-2.419a2.533,2.533,0,0,0,.253-3.8l-3-3.2a2.533,2.533,0,0,0-1.8-.747h-.152a2.533,2.533,0,0,0-1.849.975l-2.533,3.192-.557-4.4a2.533,2.533,0,0,0-2.533-2.217Z",
    transform: "translate(3.623 -1.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119915",
    "data-name": "Path 119915",
    d: "M284.69,21.654,286.083,32.5l.1.1,6.511-8.373,3.319,3.382L287.7,34.093v.089l10.627,1.267-1.368,4.864-9.817-4-.1.089,3.673,10.133-4.585,1-1.267-10.691-.1-.1-6.409,8.183-3.319-3.344,8.233-6.245-.1-.089-10.627-1.457,1.267-4.725,9.956,3.851.1-.089-3.8-9.931,4.636-1.267m0-2.533a2.939,2.939,0,0,0-.659.089l-4.636,1.267a2.475,2.475,0,0,0-1.71,3.319l1.811,4.737-4.687-1.837a2.533,2.533,0,0,0-3.357,1.672L270.2,33.067a2.552,2.552,0,0,0,2.1,3.192l4.763.646-3.458,2.622a2.533,2.533,0,0,0-.266,3.8l3.319,3.369a2.533,2.533,0,0,0,1.811.76h.139a2.533,2.533,0,0,0,1.849-.963l2.635-3.445.557,4.775a2.849,2.849,0,0,0,3.053,2.242l4.585-1a2.55,2.55,0,0,0,1.849-3.344l-1.8-4.978,4.712,1.925a2.748,2.748,0,0,0,.95.177A2.408,2.408,0,0,0,299.383,41l1.368-4.864a2.533,2.533,0,0,0-2.077-3.217l-4.687-.557,3.585-2.774a2.533,2.533,0,0,0,.253-3.8l-3.331-3.369a2.533,2.533,0,0,0-1.8-.76h-.152a2.533,2.533,0,0,0-1.849.975l-2.85,3.661-.646-5a2.533,2.533,0,0,0-2.533-2.217Z",
    transform: "translate(49.888 -0.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119916",
    "data-name": "Path 119916",
    d: "M271.764,65.835,270.193,79.49l.089.152L280.757,71.4l3.04,5.067-12.173,5.447.089.152,12.591,4.75-3.141,5.523L270.4,84.443l-.152.089,1.406,13.528-5.9-.165L267.5,84.443l-.089-.152-10.3,8.043-3.04-5.13,11.919-5.067-.089-.152-12.527-4.991,3.027-5.358,10.843,7.739.139-.089-1.647-13.275,6.029-.114m0-2.533h0l-6.029.114a2.565,2.565,0,0,0-2.47,2.85l.975,7.777-6.333-4.5a2.533,2.533,0,0,0-1.457-.469,2.787,2.787,0,0,0-.557,0,2.533,2.533,0,0,0-1.647,1.267l-3.027,5.358a2.533,2.533,0,0,0,1.267,3.6l7.081,2.825-6.447,2.774a2.533,2.533,0,0,0-1.178,3.61l3.04,5.067a2.533,2.533,0,0,0,1.71,1.191,2.8,2.8,0,0,0,.469,0,2.533,2.533,0,0,0,1.558-.545l5.573-4.345-.963,7.6a2.533,2.533,0,0,0,2.432,2.863l5.9.165h.076a2.533,2.533,0,0,0,2.533-2.8l-.836-8.069,6.333,4.623a2.533,2.533,0,0,0,1.495.494,2.609,2.609,0,0,0,2.2-1.267l3.027-5.5a2.533,2.533,0,0,0-1.267-3.61l-7.043-2.66,6.663-2.939A2.546,2.546,0,0,0,286,75.234l-3.04-5.067a2.533,2.533,0,0,0-1.71-1.267,2.925,2.925,0,0,0-.469,0,2.533,2.533,0,0,0-1.571.532l-5.8,4.585.9-7.853a2.531,2.531,0,0,0-2.521-2.825Zm0,5.067Z",
    transform: "translate(44.763 10.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119917",
    "data-name": "Path 119917",
    d: "M44.807,64.653a6.333,6.333,0,1,1-6.333,6.333,6.333,6.333,0,0,1,6.333-6.333m0-2.533a8.867,8.867,0,1,0,8.867,8.867,8.867,8.867,0,0,0-8.867-8.867Z",
    transform: "translate(-12.557 10.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119918",
    "data-name": "Path 119918",
    d: "M301.137,53.7a8.575,8.575,0,1,1-.051,0m0-2.533a11.1,11.1,0,1,0,11.1,11.1A11.1,11.1,0,0,0,301.086,51.17Z",
    transform: "translate(55.189 7.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119919",
    "data-name": "Path 119919",
    d: "M227.717,64.2a6.333,6.333,0,1,1-6.333,6.333,6.333,6.333,0,0,1,6.333-6.333m0-2.533a8.867,8.867,0,1,0,8.867,8.867,8.867,8.867,0,0,0-8.867-8.867Z",
    transform: "translate(36.219 10.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119920",
    "data-name": "Path 119920",
    d: "M256.2,11.763a3.179,3.179,0,1,1-3.179,3.179,3.179,3.179,0,0,1,3.179-3.179m0-2.533a5.713,5.713,0,1,0,5.713,5.713A5.713,5.713,0,0,0,256.2,9.23Z",
    transform: "translate(44.656 -3.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119921",
    "data-name": "Path 119921",
    d: "M113.141,56.6A4.155,4.155,0,1,1,109,60.758a4.155,4.155,0,0,1,4.142-4.155m0-2.533a6.678,6.678,0,1,1-.013,0Z",
    transform: "translate(6.243 8.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119922",
    "data-name": "Path 119922",
    d: "M72.411,10.993a4.142,4.142,0,1,1-2.933,1.218,4.155,4.155,0,0,1,2.933-1.218m0-2.533a6.688,6.688,0,1,0,6.675,6.688A6.688,6.688,0,0,0,72.411,8.46Z",
    transform: "translate(-4.619 -3.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119923",
    "data-name": "Path 119923",
    d: "M135.153,7.723a4.142,4.142,0,1,1-2.937,1.209,4.155,4.155,0,0,1,2.937-1.209m0-2.533a6.669,6.669,0,1,1-.013,0Z",
    transform: "translate(12.109 -4.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119924",
    "data-name": "Path 119924",
    d: "M206.308,21.423a4.155,4.155,0,1,1-4.142,4.155,4.155,4.155,0,0,1,4.142-4.155m0-2.533A6.688,6.688,0,1,0,213,25.578,6.688,6.688,0,0,0,206.308,18.89Z",
    transform: "translate(31.091 -1.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119925",
    "data-name": "Path 119925",
    d: "M78.4,37.093a5.345,5.345,0,1,1-5.345,5.333A5.345,5.345,0,0,1,78.4,37.093m0-2.533a7.9,7.9,0,1,0,.038,0Z",
    transform: "translate(-3.325 3.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119926",
    "data-name": "Path 119926",
    d: "M260.672,42.263a5.345,5.345,0,1,1-3.835,1.57,5.345,5.345,0,0,1,3.835-1.57m0-2.533a7.879,7.879,0,1,0,7.815,7.942,7.879,7.879,0,0,0-7.815-7.942Z",
    transform: "translate(45.253 4.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119927",
    "data-name": "Path 119927",
    d: "M55.742,29.685,47.42,35.816v.127l9.905,1.545-1.267,4.294-9.272-3.889v.127l3.8,9.361-4.649,1.1-1.191-9.956h-.127l-6.7,7.613-2.939-3.331,8.271-5.941v-.127L33.55,35.2,34.817,30.9l8.943,3.927V34.7l-3.61-9.475,4.509-1.077L46,34.093h.127l6.447-7.6Z",
    transform: "translate(-13.195 0.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119928",
    "data-name": "Path 119928",
    d: "M228.51,31.4l6.739,8.677h.139L236.756,29.5l4.6,1.267-3.939,9.88h.139l9.842-4.332,1.267,4.915L238.2,42.8v.127l8.36,6.941-3.458,3.2-6.536-8.613h-.139l-1.381,10.349-4.6-1.267,3.927-9.6h-.127l-9.981,4.079L223,43.269l10.513-1.7v-.127l-8.373-6.65Z",
    transform: "translate(37.325 1.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119929",
    "data-name": "Path 119929",
    d: "M91.435,64.121l-5.776,3.445v.076l6.333,1.634-1.089,2.7-5.713-3.141v.089l1.887,6.333L84,75.673l-.139-6.523h-.089l-4.839,4.56-1.7-2.343,5.738-3.319v-.089L76.78,66.338l1.089-2.7,5.523,3.053v-.076l-1.773-6.333,3.04-.443.19,6.536h.076L89.6,61.791Z",
    transform: "translate(-1.667 9.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119930",
    "data-name": "Path 119930",
    d: "M110,17.51l1.267,10.26.1.089,6.156-7.9,3.192,3.243L112.8,29.328l.089.1,10.057,1.191-1.267,4.6-9.285-3.8-.1.089,3.471,9.614-4.332.95-1.191-10.133-.089-.089-6.067,7.727L100.946,36.4l7.777-5.9-.089-.1L98.59,29.011l1.267-4.459,9.323,3.661.1-.089-3.61-9.386Z",
    transform: "translate(4.149 -1.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119931",
    "data-name": "Path 119931",
    d: "M284.177,21.11l1.393,10.843.1.1,6.511-8.373,3.319,3.382-8.309,6.485v.089L297.819,34.9l-1.368,4.864-9.817-4-.1.089,3.673,10.133-4.585.988-1.267-10.691-.1-.1-6.409,8.183-3.319-3.331,8.233-6.245-.1-.089L272.03,33.245,273.3,28.52l9.956,3.851.1-.089-3.8-9.931Z",
    transform: "translate(50.4 -0.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119932",
    "data-name": "Path 119932",
    d: "M271.242,65.31l-1.571,13.655.089.152,10.475-8.246,3.04,5.067L271.1,81.384l.089.152,12.591,4.75-3.141,5.523-10.767-7.891-.152.089,1.406,13.528-5.9-.165,1.748-13.452-.089-.152-10.3,8.043-3.04-5.13,11.919-5.067-.089-.152L252.85,76.469l3.027-5.358,10.843,7.739.139-.089-1.647-13.275Z",
    transform: "translate(45.285 11.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10267",
    "data-name": "Ellipse 10267",
    cx: 6.371,
    cy: 6.371,
    r: 6.371,
    transform: "translate(25.878 75.139)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10268",
    "data-name": "Ellipse 10268",
    cx: 8.55,
    cy: 8.55,
    r: 8.55,
    transform: "translate(347.776 61.295)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10269",
    "data-name": "Ellipse 10269",
    cx: 6.371,
    cy: 6.371,
    r: 6.371,
    transform: "translate(257.564 74.582)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10270",
    "data-name": "Ellipse 10270",
    cx: 3.179,
    cy: 3.179,
    r: 3.179,
    transform: "translate(297.616 8.158)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10271",
    "data-name": "Ellipse 10271",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(115.241 64.968)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10272",
    "data-name": "Ellipse 10272",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(63.663 7.195)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10273",
    "data-name": "Ellipse 10273",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(143.121 3.041)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10274",
    "data-name": "Ellipse 10274",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(233.257 20.407)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10275",
    "data-name": "Ellipse 10275",
    cx: 5.345,
    cy: 5.345,
    r: 5.345,
    transform: "translate(69.73 40.23)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10276",
    "data-name": "Ellipse 10276",
    cx: 5.345,
    cy: 5.345,
    r: 5.345,
    transform: "translate(300.529 46.791)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10277",
    "data-name": "Ellipse 10277",
    cx: 29.133,
    cy: 29.133,
    r: 29.133,
    transform: "translate(160.892 56.291)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10278",
    "data-name": "Ellipse 10278",
    cx: 29.019,
    cy: 26.6,
    rx: 29.019,
    ry: 26.6,
    transform: "matrix(1, -0.003, 0.003, 1, 160.907, 56.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119933",
    "data-name": "Path 119933",
    d: "M174.167,49.763A29.133,29.133,0,1,1,145.033,78.9a29.133,29.133,0,0,1,29.133-29.133m0-2.533A31.667,31.667,0,1,0,205.833,78.9,31.667,31.667,0,0,0,174.167,47.23Z",
    transform: "translate(15.859 6.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119934",
    "data-name": "Path 119934",
    d: "M167.888,78.38a4.231,4.231,0,1,0,3.4,1.726,4.205,4.205,0,0,0-3.4-1.726Z",
    transform: "translate(21.504 14.835)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119935",
    "data-name": "Path 119935",
    d: "M170.325,59.966c5.168,0,10.691,4.028,10.691,9.348,0,7.068-7.6,7.182-7.6,9.791v.342a1.469,1.469,0,0,1-1.495,1.52h-4.408a1.457,1.457,0,0,1-1.457-1.469v-.6c0-3.8,2.85-5.269,5-6.473,1.849-1.039,2.989-1.748,2.989-3.116,0-1.824-2.318-3.027-4.193-3.027-2.381,0-3.509,1.1-5.067,3.015a1.469,1.469,0,0,1-1.14.545,1.431,1.431,0,0,1-.887-.291l-2.622-1.989a1.457,1.457,0,0,1-.317-2A11.78,11.78,0,0,1,170.3,60.017m-.608,24.067a1.645,1.645,0,1,1-.025-.1m.608-26.6a14.212,14.212,0,0,0-12.553,6.625,3.99,3.99,0,0,0,.861,5.472l2.622,1.989a4,4,0,0,0,5.535-.684c1.457-1.824,1.938-2.065,3.065-2.065a2.863,2.863,0,0,1,1.495.469,14.072,14.072,0,0,1-1.533.925l-.152.089c-2.293,1.267-6.143,3.445-6.143,8.6v.6a4.015,4.015,0,0,0,1.989,3.471,6.751,6.751,0,1,0,8.411,0,3.977,3.977,0,0,0,1.989-3.293c.3-.215.8-.507,1.191-.722,2.407-1.393,6.447-3.724,6.447-9.589,0-7-6.967-11.881-13.224-11.881Z",
    transform: "translate(19.725 9.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119936",
    "data-name": "Path 119936",
    d: "M169.782,59.422a11.78,11.78,0,0,0-10.475,5.548,1.444,1.444,0,0,0,.317,2l.874.671,1.748,1.267a1.457,1.457,0,0,0,2.027-.253c1.52-1.913,2.66-3.015,5.067-3.015,1.786,0,3.977,1.1,4.18,2.787h0a1.374,1.374,0,0,1,0,.228c0,1.368-1.14,2.077-2.989,3.116-2.153,1.267-5,2.711-5,6.485v.6a1.457,1.457,0,0,0,1.444,1.571h4.408a1.469,1.469,0,0,0,1.469-1.457v-.355c0-2.609,7.6-2.723,7.6-9.779v-.089C180.409,63.412,174.925,59.422,169.782,59.422Z",
    transform: "translate(20.269 9.777)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119937",
    "data-name": "Path 119937",
    d: "M179.586,65.213a.747.747,0,0,1-1.191.849c-1.457-1.444-3.661-4.1-7.081-4.269-7.093-.355-10.032,4.205-10.817,5.89l-.874-.671a1.444,1.444,0,0,1-.317-2,11.78,11.78,0,0,1,10.475-5.548A11.4,11.4,0,0,1,179.586,65.213Z",
    transform: "translate(20.269 9.787)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119938",
    "data-name": "Path 119938",
    d: "M171.916,83.331a4.231,4.231,0,0,1-8.056,0,4.224,4.224,0,0,1,8.056,0Z",
    transform: "translate(21.555 15.368)",
    fill: "#dca93b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllPasswordreq);
export default __webpack_public_path__ + "static/media/ill_passwordreq.f5d6742f9326f73f168ff592c0890bec.svg";
export { ForwardRef as ReactComponent };